import React from "react";
import { useTranslation } from "react-i18next";

/**
 * Muted indicator shown next to read-only text when Arabic translation is missing.
 */
export default function MissingTranslationBadge({ show = false }) {
  const { t } = useTranslation("translation");
  if (!show) return null;

  return (
    <span
      className="ms-1 text-muted"
      style={{ fontSize: "0.75rem", fontStyle: "italic", whiteSpace: "nowrap" }}
      title={t("Arabic translation missing")}
    >
      <i className="bi bi-exclamation-circle me-1" aria-hidden="true" />
      {t("Arabic translation missing")}
    </span>
  );
}

/**
 * Read-only label with optional missing-Arabic flag.
 */
export function LocalizedReadOnlyText({ text, isMissingTranslation = false, className = "" }) {
  return (
    <span
      className={className}
      style={isMissingTranslation ? { fontStyle: "italic", color: "#6c757d" } : undefined}
    >
      {text}
      <MissingTranslationBadge show={isMissingTranslation} />
    </span>
  );
}
